import { styled } from '@mui/material/styles';
import * as React from 'react';
const StyledContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'borderTop',
})(({ borderTop, theme }) => ({
    borderTop: borderTop ? `1px solid ${theme.palette.black40.main}` : 'none',
    backgroundColor: theme.palette.white.main,
    marginTop: theme.spacing(16),
}));
export const Container = (props) => React.createElement(StyledContainer, Object.assign({}, props));
//# sourceMappingURL=styles.js.map